import { screenSmMin, screenXsMax, spacer24, spacer32 } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { zIndexFixed } from "../../styles";
export var Banner = styled.aside.withConfig({
  displayName: "Banner",
  componentId: "sc-1bnzyty-0"
})(["position:sticky;top:0;z-index:", ";@media (max-width:", "){margin-inline-start:-", ";margin-inline-end:-", ";}@media (min-width:", "){margin-inline-start:-", ";margin-inline-end:-", ";}"], zIndexFixed, screenXsMax, spacer24, spacer24, screenSmMin, spacer32, spacer32);
export default Banner;